import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

class ConnectButton extends React.Component {
  handleConnectQwc = e => {
    e.preventDefault();

    const form = document.createElement('form');

    form.setAttribute('method', 'post');
    form.setAttribute('action', 'api/DownloadQwc');

    document.body.appendChild(form);

    form.submit();
  }

  render() {
    const { label, link, style } = this.props;

    return link ? (
      <a href="#" onClick={ e => this.handleConnectQwc(e) } style={ style }>{ label }</a>
    ) : (
      <Button onClick={ e => this.handleConnectQwc(e) } style={ style }>{ label }</Button>
    );
  }
}

ConnectButton.defaultProps = {
  label: 'Connect to QuickBooks Now',
  link: false,
  style: {},
};

ConnectButton.propTypes = {
  label: PropTypes.string,
  link: PropTypes.bool,
  style: PropTypes.object,
};

export default ConnectButton;



// WEBPACK FOOTER //
// ./src/components/Status/components/ConnectButton.js